module.exports = __webpack_public_path__ + "static/media/app-wash.332cb998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-wash.png
// module id = 88
// module chunks = 0